import { atom } from 'jotai';
import _merge from 'lodash/merge';
export const $I18nText = atom({});
$I18nText.debugLabel = '$I18nText';
export const $UpdateI18nText = atom(null, (get, set, update) => {
    const i18n = get($I18nText);
    return _merge(i18n, update);
});
$UpdateI18nText.debugLabel = '$UpdateI18nText';
